import { render, staticRenderFns } from "./HyphenContent.vue?vue&type=template&id=87207728&scoped=true"
import script from "./HyphenContent.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenContent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenContent.vue?vue&type=style&index=0&id=87207728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87207728",
  null
  
)

export default component.exports